import useFetchAllQuery, {Status, useFetchAllQueryHelper} from "../../../hooks/useFetchAllQuery";
import {findHand} from "../../../utils/awsAmplifyUtil";
import {Dict} from "../../../types/pj1dbApi";
import {HandDocument} from "../../equipmentdb/types/pj1dbApiHand";

export interface UseHandParams {
  onChange: (newData: Dict<HandDocument>[], newStatus: Status) => void;
  enableAutoFetch?: boolean;
  initialStatus?: Status;
  handIds?: string[];
}

export function useHand(params: UseHandParams) {
  const result = useFetchAllQuery({
    queryFn: () => findHand({
      "query": {
        "handId": {
          "$in": params.handIds ?? []
        }
      }
    }),
    needToFetchMore: () => false,
    enableAutoFetch: params.enableAutoFetch,
  })
  const helper = useFetchAllQueryHelper({
    onChange: params.onChange,
    data: result.data,
    status: result.status,
    initialStatus: params.initialStatus,
  });

  return {
    ...result,
    ...helper,
  };
}
